import {useMutation} from '@apollo/client';
import {UPDATE_CART} from "../productTypeDefs";

export const useMutationUpdateCart = (options?: any): any => (
  useMutation(UPDATE_CART, options)
);
